import React from 'react'
import { Link, useParams } from 'react-router-dom'
import TopBar from '../TopBar/TopBar';
import Ads from '../Ads/Ads'
import "./log.css"
import { Foot } from '../Foot/Foot';
import Foot2 from '../Foot2/Foot2';


const Log = () => {
  let { id } = useParams();
  return (
    <>
      <TopBar />

    <div className='log'>
      
      <div className="loghead1">{id.charAt(0).toUpperCase().concat(id.slice(1))} Posts</div>
        <div className="breadcrumbs"><Link to="/">Nairaland Forum </Link>/&nbsp;<Link to={`/` }>{id.charAt(0).toUpperCase().concat(id.slice(1))}  Posts</Link></div>
        <Ads />
        <div className="logpost"></div>
        <Ads />
      
        <Foot2 />

      </div>
    </>
  
  )
}

export default Log